import { useMemo } from 'react';

export const useEnvironment = () => {
  const isNativeWebView = useMemo(() => {
    return sessionStorage.getItem('isNativeWebView') === 'true';
  }, []);

  return {
    isNativeWebView,
    isWeb: !isNativeWebView,
  };
}; 